import { useState } from "react";
import Reveal from "@/components/SectionReveal";

const PAIRS = [
  {
    title: "Algae bloom rescue — Tampa, FL",
    before:
      "https://customer-assets.emergentagent.com/job_d5150541-0200-412c-b6e8-dd4165cb6378/artifacts/4lxfepvv_image.png",
    after:
      "https://customer-assets.emergentagent.com/job_d5150541-0200-412c-b6e8-dd4165cb6378/artifacts/4lxfepvv_image.png",
    note: "Heavy green algae cleared in 48 hours.",
  },
  {
    title: "Storm aftermath cleanup",
    before:
      "https://customer-assets.emergentagent.com/job_d5150541-0200-412c-b6e8-dd4165cb6378/artifacts/024nyuh2_image.png",
    after:
      "https://customer-assets.emergentagent.com/job_d5150541-0200-412c-b6e8-dd4165cb6378/artifacts/024nyuh2_image.png",
    note: "Murky, debris-filled water restored to sparkling blue.",
  },
  {
    title: "Neglected pool revival",
    before:
      "https://customer-assets.emergentagent.com/job_d5150541-0200-412c-b6e8-dd4165cb6378/artifacts/08auoltw_image.png",
    after:
      "https://customer-assets.emergentagent.com/job_d5150541-0200-412c-b6e8-dd4165cb6378/artifacts/08auoltw_image.png",
    note: "Full chemical reset, deep clean, equipment tune-up.",
  },
];

function BeforeAfterCard({ pair, index }) {
  const [hover, setHover] = useState(false);

  return (
    <Reveal
      direction={index % 2 === 0 ? "left" : "right"}
      delay={index * 0.05}
      className="rounded-3xl overflow-hidden bg-white border border-slate-100 shadow-[0_12px_40px_rgba(10,37,64,0.08)]"
      testId={`before-after-${index}`}
    >
      <div
        className="relative aspect-[4/3] w-full bg-slate-100"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {/* The provided assets ARE side-by-side before/after collages — show them whole */}
        <img
          src={pair.before}
          alt={pair.title}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        <div
          className={`absolute top-3 left-3 px-3 py-1 rounded-full text-[10px] tracking-[0.2em] uppercase font-bold transition-all ${
            hover ? "bg-amber-300 text-slate-900" : "bg-slate-900/80 text-white"
          }`}
        >
          Before / After
        </div>
      </div>
      <div className="p-5">
        <p className="font-heading text-lg font-bold text-slate-900">{pair.title}</p>
        <p className="mt-1 text-sm text-slate-600">{pair.note}</p>
      </div>
    </Reveal>
  );
}

export default function BeforeAfter() {
  return (
    <section id="gallery" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <Reveal className="max-w-3xl">
          <p className="text-xs tracking-[0.22em] uppercase font-bold text-sky-700">Real Tampa Bay Pools</p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Green to clean — without the headache.
          </h2>
          <p className="mt-4 text-slate-600">
            See what our green pool cleanup specialists deliver for homeowners across Tampa Bay.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PAIRS.map((p, i) => (
            <BeforeAfterCard key={p.title} pair={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
